import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';

import Backdrop from 'material-ui/Modal/Backdrop';

import styles from 'styles/components/Loading';

@withStyles(styles)
@observer
export default class Loading extends Component {

  static propTypes = {
    visible: PropTypes.bool
  }

  static defaultProps = {
    visible: false
  }

  render() {
    const { classes, visible } = this.props;

    return visible && (
      <div className={ classes.root }>
        <Backdrop open={true} />
        <CircularProgress size={100} thickness={1} />
      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/components/Loading.js